// src/v3/interactions/chevron-left.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ChevronLeftIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ChevronLeftIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M15.8069 18.1911C15.8689 18.253 15.918 18.3266 15.9515 18.4075C15.9851 18.4885 16.0023 18.5752 16.0023 18.6628C16.0023 18.7505 15.9851 18.8372 15.9515 18.9182C15.918 18.9991 15.8689 19.0726 15.8069 19.1346C15.745 19.1965 15.6714 19.2457 15.5905 19.2792C15.5095 19.3127 15.4228 19.33 15.3352 19.33C15.2475 19.33 15.1608 19.3127 15.0798 19.2792C14.9989 19.2457 14.9254 19.1965 14.8634 19.1346L8.19556 12.4668C8.13356 12.4048 8.08438 12.3313 8.05083 12.2503C8.01727 12.1694 8 12.0826 8 11.995C8 11.9074 8.01727 11.8206 8.05083 11.7397C8.08438 11.6587 8.13356 11.5852 8.19556 11.5233L14.8634 4.85541C14.9885 4.73029 15.1582 4.66 15.3352 4.66C15.5121 4.66 15.6818 4.73029 15.8069 4.85541C15.932 4.98052 16.0023 5.15022 16.0023 5.32716C16.0023 5.5041 15.932 5.67379 15.8069 5.79891L9.60998 11.995L15.8069 18.1911Z"
  }
) });

export {
  ChevronLeftIcon
};
